import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';

import { filterLaajuus } from '../../reducers/filter';
import Dropdown from './Dropdown.jsx';
import scopeTextsLaajuus from '../../texts';

const id = 'dropdown-laajuus';
const title = 'Laajuus';
const values = [
  { key: '0', text: '-' },
  { key: '1', text: scopeTextsLaajuus(1) },
  { key: '2', text: scopeTextsLaajuus(2) },
  { key: '4', text: scopeTextsLaajuus(4) },
  { key: '8', text: scopeTextsLaajuus(8) }
];

const DropdownLaajuus = ({ changeFilter }) => (
  <Dropdown id={id} defaultTitle={title} filter={filterLaajuus} changeFilter={changeFilter}>
    {values.map(item => <MenuItem key={item.key} eventKey={item.key}>{item.text}</MenuItem>)}
  </Dropdown>
);

DropdownLaajuus.propTypes = {
  changeFilter: PropTypes.func.isRequired
};

export default DropdownLaajuus;



// WEBPACK FOOTER //
// ./src/components/eventFilter/DropdownLaajuus.jsx